import {
  groupDetailApi,
  groupEditApi,
  groupListApi,
  groupRegisterApi,
} from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { groupActions } from "./actions";

export function* groupSaga() {
  yield takeEveryFsa(groupActions.fetchGroups.started, function* (action) {
    yield* makeAsyncApiCall(action, groupActions.fetchGroups, groupListApi);
  });

  yield takeEveryFsa(groupActions.getGroupDetails.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      groupActions.getGroupDetails,
      groupDetailApi,
    );
  });

  yield takeEveryFsa(groupActions.registerNewGroup.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      groupActions.registerNewGroup,
      groupRegisterApi,
    );
  });

  yield takeEveryFsa(groupActions.updateGroup.started, function* (action) {
    yield* makeAsyncApiCall(action, groupActions.updateGroup, groupEditApi);
  });
}
